export const bannerSliderOptions = (instance, options) => {
    instance.customNavTexts = [...instance.querySelectorAll('[data-custom-nav-text]')].map(el => el.dataset.customNavText)

    return {
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoHeight: true,
        spaceBetween: 0,
        cssMode: false,
        pagination: {
            el: document.querySelector('.js-index-banner-pagination'),
            bulletClass: 'c-link--pagination',
            bulletActiveClass: 'is-active',
            renderBullet: function (index, className) {
                return `
                    <button class="c-link ${className}" type="button" data-slide-index="${index}" data-name="${instance.customNavTexts[index]}">
                        <span class="cxs-is-hidden" data-slide-index="${index}">${instance.customNavTexts[index]}</span>
                    </button>
                `
            }
        },
        breakpoints: {
            600: {
                loop: false,
            }
        },
        on: {
            init(swiper) {
                requestAnimationFrame(() => {
                    document.querySelectorAll('.js-index-banner-pagination .c-link').forEach(button => {
                        button.addEventListener('click', event => {
                            swiper.slideTo(event.target.dataset.slideIndex)
                        })
                    })
                })

                // Play video only if on first slide
                if (swiper.activeIndex === 0) {
                    const firstSlideVideo = swiper.slides[0].querySelector('video');
                    if (firstSlideVideo) {
                        firstSlideVideo.play();
                    }
                }
            },
            transitionEnd: function () {
                const slides = document.querySelectorAll('.swiper-slide video');
                slides.forEach((video) => {
                    if (video.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
                        video.play()
                    } else {
                        video.pause();
                    }
                });
            }
        }
    }
}